import angular from "angular";
import { Translations } from "@salaxy/core";

/**
 * Controller rendering a Spinner (please wait) user interfaces.
 */
export class SpinnerController implements angular.IController {

  /**
   * For NG-dependency injection
   * @ignore
   */
  public static $inject = [];

  /** If true, the spinner is shown full screen. */
  public fullScreen: boolean;

  /**
   * Heading is the larger text under the spinner.
   * The text is translated.
   * Also, if language dictionaries are not available, SALAXY.UI_Terms.loading and .loginInProgress are
   * resolved to Finnish terms "Ladataan..." and "Kirjaudutaan..."
   */
  public heading: string;

  /**
   * Small text - use pre for line breaks.
   * The text is translated.
   */
  public text: string;

  /**
   * Creates a new SpinnerController
   * @ignore
   */
  constructor() {
    //
  }

  /**
   * Implement IController
   */
  public $onInit = () => {
    // initialization
  };

  /**
   * Gets the header with default Finnish texts for "SALAXY.UI_Terms.loading" and "SALAXY.UI_Terms.loginInProgress".
   * Other untranslated language terms (starting with "SALAXY.") return an empty text. Other texts are printed as is.
   */
  public getHeading() {
    if (!this.heading) {
      return null;
    }
    const knownTerms = {
      "SALAXY.UI_Terms.loading": "Ladataan...",
      "SALAXY.UI_Terms.loginInProgress": "Kirjaudutaan...",
    };
    let defaultText = this.heading;
    if (defaultText.startsWith("SALAXY.")) {
      defaultText = knownTerms[this.heading];
    }
    return Translations.getWithDefault(this.heading, defaultText);
  }

}
